module.exports = __webpack_public_path__ + "static/media/sf_900.aa6b38a404eaf79ea732f20d0cce8314.png";